
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/pdm-pmm",
      function () {
        return require("private-next-pages/cases/pdm-pmm/index.tsx");
      }
    ]);
  